import React, { useCallback, useEffect, useMemo, useState } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CustomSwitch from "../../../components/Elements/CustomSwitch/CustomSwitch";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as FilterIcon } from "../../../assets/svgs/filter-icon.svg";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import dayjs from "dayjs";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { Badge } from "../../../components/Elements/TextStyles/Badge";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import AddNewProject from "../../Projects/DailogBoxes/AddNewProject";
import ProjectFilter from "../../Projects/DailogBoxes/ProjectFilter";
import { useDebounce } from "../../../hooks/debouncing";
const CustomerProjects = ({ clientId, basicInformation }) => {
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortOrder, setSortOrder] = useState("-createdAt");
  const [searchTerm, setSearchTerm] = useState("");
  const [openAddNew, setOpenAddNew] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState("");
const [projectType, setProjectType] = useState(null);
  const navigate = useNavigate();
  const debouncedSearch = useDebounce(searchTerm, 500);
  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: <div className="px-6">Project name</div>, key: "projectName" },
      { label: <div className="px-6">Customer name</div>, key: "customerName" },
      { label: "Start date", key: "startDate" },
      { label: "End Date", key: "endDate" },
      { label: "Project type", key: "projectType" },
      { label: <div className="px-10">Status</div>, key: "status" },
      { label: "Action", key: "action" },
    ],
    [],
  );
  const fetchProjects = async () => {
    try {
      const skip = (currentPage - 1) * pageSize;
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOMER_FILTERED_PROJECTS(
          pageSize,
          skip,
          sortOrder,
          debouncedSearch,
          filterData,
        ),
        headers: { client: clientId },
      });

      if (response.success) {
        setPageSize(response.limit);
        setTotalRecords(response.total);
        setTableData(
          response.data.map((item, index) => ({
            key: item._id,
            serial: index + 1,
            projectName: (
              <div
                style={{
                  textAlign: "center",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  maxWidth: "300px",
                }}
              >
                {item.name}
              </div>
            ),
            customerName: (
              <div
                style={{
                  textAlign: "center",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  maxWidth: "300px",
                }}
              >
                {item?.client_id?.organization?.name || item?.client_id?.name}
              </div>
            ),
            startDate: dayjs(item.startDate).format("DD/MM/YYYY"),
            endDate: dayjs(item.endDate).format("DD/MM/YYYY"),
            projectType: item.project_type,
            
            status: (
              <div className="flex justify-center items-center">
                {" "}
                <Badge text={item.status} />{" "}
              </div>
            ),
            
            action: (
              <div className="flex gap-4 items-center justify-center">
                <GreenEye
                  onClick={() => {
                    navigate("/projects/project-page", {
                      state: { projectId: item._id },
                    });
                  }}
                />
                <CustomSwitch
                  checked={true}
                  onChange={(checked) =>
                    console.log(`Custom switch toggled, Status: ${checked}`)
                  }
                  // onClick={() => handleForm(item)}
                />
              </div>
            ),
          })),
        );
      }


    } catch (error) {
      console.log("Error is fetching Projects", error);
    }
  };

  const handleSort = useCallback(() => {
    setSortOrder((prevOrder) =>
      prevOrder === "createdAt" ? "-createdAt" : "createdAt",
    );
  }, []);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  useEffect(() => {
    if (clientId) {
      fetchProjects();
    }
  }, [
    clientId,
    currentPage,
    pageSize,
    sortOrder,
    debouncedSearch,
    filterData,
    openAddNew,
  ]);
  return (
    <div
      style={{ paddingLeft: "40px", paddingRight: "40px", paddingTop: "20px" }}
    >
      <CardsBorder>
        <div className="flex justify-between">
          <div className="flex gap-8 my-4 font-medium">
            <p className="text-[#06513D] pt-2 px-10 text-xl">Projects</p>
            <SearchBar
              width="300px"
              onSearch={(value) => setSearchTerm(value)}
            />
          </div>
          <div className="flex gap-4 items-center px-10">
            <Button
              type="primary"
              style={{ background: "#06513D" }}
              className="text-[12px] font-light px-2 py-5 hover:!bg-[#387464] hover:!text-[#ffffff]"
              onClick={() => setOpenAddNew(true)}
            >
              + ADD NEW
            </Button>
            <Button
              onClick={() => setFilterOpen(true)}
              style={{ background: "#E6EDEB", border: "solid 1px #06513D" }}
              className="text-[12px] text-[#06513D] font-light px-4 py-5 hover:!bg-[#F8F8F8] hover:!text-[#06513D]"
              // onClick={() => setFilterOpen(true)}
            >
              <FilterIcon /> FILTER
            </Button>
          </div>
        </div>
        
        <Tables
          data={tableData}
          headers={headers}
          pageSize={pageSize}
          total={totalRecords}
          current={currentPage}
          onChange={handlePageChange}
          onSort={handleSort}
        />
      </CardsBorder>
    
      {openAddNew && (
        <AddNewProject
          onOpen={openAddNew}
          onClose={() => setOpenAddNew(false)}
          name={basicInformation.organizationName || basicInformation.name}
          onSave={() => {
            setOpenAddNew(false);
            // setOpenSuccessPopup(true);
          }}
          clientId={clientId}
          customer={true}
        />
      )}

      {filterOpen && (
        <ProjectFilter
          onOpen={filterOpen}
          onClose={() => setFilterOpen(false)}
          setFilterData={setFilterData}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          status={status}
          setStatus={setStatus}
          projectType={projectType}
          setProjectType={setProjectType}
          setEndDate={setEndDate}
          clientId={clientId}
          customer={true}
        />
      )}
    </div>
  );
};

export default CustomerProjects;
